const truncate = (str, len) =>
  len && str && str.length > len ? str.slice(0, len) : str;

export default truncate;
